<template>
	<div>
		<b-img src="/images/importer/module-cock/cock.jpg"></b-img>
		<p>
			The Cock module is for setting up physics properties for your character's cock and balls. Your character's cock should be in a fully erect (and unsheathed, if applicable) position when
			building the character package - the orientation that it has will be the target orientation when becoming erect in-game.
		</p>
        
		<p>
			<span class="font-weight-bold">Clippable Cock Materials:</span> If your character has a large and/or long cock that may clip through partners during sex, you will want to assign its material(s)
			a shader that supports a clipping plane, and reference those materials here - you might use the CharacterShader included in the importer's "_SharedResources/Shaders" folder, or at least look at 
			it for an example of setting up the ClippingPlanePosition and ClippingPlaneNormal properties. One thing to note - if this field is used, your character's cock should use a different material 
			than the rest of its body, since the clipping plane extends infinitely. Otherwise, parts of your character's body will become invisible when penetrating your partner, if they pass the plane.
		</p>

		<p>
			<span class="font-weight-bold">Cock Base / Cock Tip:</span> The first and last bone of your cock's rig. The importer expects at cocks to be made of at least two bones, and the tip must be
			a descendant of the base.
		</p>

		<p>
			<span class="font-weight-bold">Cock Rotation Base:</span> Some interactions involve rotating the base of the cock to improve alignment with the partner etc - the bone referenced here will
			be used for that rotation, and in most cases can be the same as the Cock Base bone. If your character has a sheath however, this should be that sheath bone so the cock doesn't clip through
			the sheath when rotating.
		</p>
        
		<b-img src="/images/importer/module-cock/cock-colliders.jpg"></b-img>
		<p>
			<span class="font-weight-bold">Set Up Cock Joints:</span> Clicking this button will set up the rigidbody and joints for each bone in the cock between the base and tip. It's recommended that
			you also assign colliders to the cock, or else it will float around and not respond correctly to gravity or collisions with objects. This button will also add an instance of the CockTip prefab
			as a child of the bone assigned in the Cock Tip field - this tip object has some child objects that are important for fluid emission and aiming your character's cock correctly during penetration,
			so select it and check its help wording for instructions on orienting it and its children correctly.
		</p>

		<p>
			<span class="font-weight-bold">Has Balls:</span> Set this flag on if your character has balls. This will enable some additional fields here for setting up the ball physics.
		</p>

		<p>
			<span class="font-weight-bold">Balls Parent:</span> This should be an object that is a parent of both Ball objects, and acts as the pivot point for them swinging - it should be positioned
			near where the balls connect to the body.
		</p>

		<p>
			<span class="font-weight-bold">Left Ball / Right Ball:</span> The bones for each ball. Like with the cock bones, it is recommended to set up colliders for these bones in order for their 
			physics to behave correctly. If your character only has a single bone controlling both balls, assign it to both of these fields.
		</p>

		<p>
			<span class="font-weight-bold">Ball Joint Spring:</span> The strength of the spring joint connecting the balls to their parent. It's best to run Play mode in order to test good Ball Joint 
			Spring values since you can see the physics in action - but keep in mind that changes made during Play mode are not preserved after exiting it, and you'll need to update the value and click 
			Set Up Ball Joints again in order to lock the value in.
		</p>

		<p>
			<span class="font-weight-bold">Set Up Ball Joints:</span> This button will add the rigidbodies and joints to the balls, connecting them to the parent with the Ball Joint Spring strength value.
		</p>
	</div>
</template>

<script>
export default {
		name: 'CockModule',
}
</script>
